import { render, staticRenderFns } from "./DialogFinalizarApuracoes.vue?vue&type=template&id=68da43b2"
import script from "./DialogFinalizarApuracoes.vue?vue&type=script&lang=js"
export * from "./DialogFinalizarApuracoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports